// src/components/sinister/ModalUpdateStatus.tsx

import { Modal, Box, Grid, Typography, Button, MenuItem, LinearProgress, Icon, Paper } from "@mui/material";
import { FormHandles } from "@unform/core";
import { VForm, VTextField } from "../../../../shared/forms";
import { useEffect, useRef, useState } from "react";
import { format } from "date-fns";

interface ModalUpdateStatusProps {
	open: boolean;
	isLoading: boolean;
	isUploading: boolean;
	handleSubmit: (data: any) => void;
	initialStatus?: string;
	isClose: () => void;
}

export const ModalUpdateStatus = ({ open, isLoading, isUploading, handleSubmit, initialStatus, isClose }: ModalUpdateStatusProps) => {
	const formRef = useRef<FormHandles>(null);
	const [formKey, setFormKey] = useState(0);
	const [initialFormData, setInitialFormData] = useState({});
	const [selectedStatus, setSelectedStatus] = useState<string | undefined>(initialStatus);

	useEffect(() => {
		if (open) {
			const initialData: any = { status: initialStatus };

			// Preenche a data automaticamente se for status "finalized"
			if (initialStatus === "finalized") {
				initialData.finalized_at = format(new Date(), "yyyy-MM-dd");
			}

			setFormKey((prevKey) => prevKey + 1);
			setInitialFormData(initialData);
			setSelectedStatus(initialStatus);
			setTimeout(() => {
				formRef.current?.setErrors({});
			}, 0);
		} else {
			setInitialFormData({});
		}
	}, [open, initialStatus]);

	const internalHandleSubmit = (data: any) => {
		if (!data.status) {
			formRef.current?.setErrors({ status: "Selecione um status" });
			return;
		}
		handleSubmit(data);
	};

	return (
		<Modal open={open} onClose={isClose} disableEnforceFocus>
			<Box
				sx={{
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "45%",
					outline: "none",
				}}
			>
				<Paper sx={{ p: 4 }}>
					<Typography variant="h5" fontWeight={300} mb={2} color="primary" textAlign="center">
						Alteração de status do sinistro
					</Typography>

					<VForm
						key={formKey}
						id="formIdUpdateStatusSave"
						ref={formRef}
						onSubmit={internalHandleSubmit}
						initialData={initialFormData}
						placeholder="Digite aqui..."
						onPointerEnterCapture={() => {}}
						onPointerLeaveCapture={() => {}}
					>
						<Grid container direction="column" spacing={2}>
							{isLoading && (
								<Grid item>
									<LinearProgress />
								</Grid>
							)}

							<Grid item>
								<Typography>Ao alterar o status, poderá ser necessário anexar novos documentos para continuar o sinistro.</Typography>
							</Grid>

							<Grid container item spacing={2}>
								<Grid item xs={12} md={6}>
									<VTextField
										fullWidth
										label="Status do Sinistro"
										name="status"
										select
										required
										onChange={(e) => {
											const value = e.target.value;
											formRef.current?.setFieldValue("status", value);
											setSelectedStatus(value);
										}}
									>
										<MenuItem value="open">Aberto</MenuItem>
										<MenuItem value="in_progress">Em andamento</MenuItem>
										<MenuItem value="in_analysis">Em análise</MenuItem>
										<MenuItem value="debts_confession">Confissão de dívidas</MenuItem>
										<MenuItem value="monthly_compensation">Indenização Mensal</MenuItem>
										<MenuItem value="finalized">Finalizado</MenuItem>
										<MenuItem value="pending">Pendente</MenuItem>
										<MenuItem value="preventive">Acordo - Preventivo</MenuItem>
										<MenuItem value="judicial">Acordo - Judicial</MenuItem>
										<MenuItem value="extrajudicial">Acordo - Extrajudicial</MenuItem>
									</VTextField>
								</Grid>

								{selectedStatus === "finalized" && (
									<>
										<Grid item xs={12} md={6}>
											<VTextField
												fullWidth
												name="finalizedAt"
												label="Data da finalização"
												type="date"
												InputLabelProps={{ shrink: true }}
												required
											/>
										</Grid>

										<Grid item xs={12}>
											<VTextField fullWidth name="finalizedNote" label="Descreva o motivo" multiline rows={3} required />
										</Grid>
									</>
								)}
							</Grid>

							<Grid container item justifyContent="center" spacing={2} mt={2}>
								<Grid item gap={2} display="flex" justifyContent="center" alignItems="center">
									<Button variant="contained" color="inherit" startIcon={<Icon>arrow_back</Icon>} onClick={isClose} sx={{ width: "160px" }}>
										Voltar
									</Button>

									<Button
										variant="contained"
										startIcon={<Icon>check</Icon>}
										onClick={() => {
											formRef.current?.submitForm();
										}}
										disabled={isUploading}
										sx={{ width: "160px" }}
									>
										Confirmar
									</Button>
								</Grid>
							</Grid>
						</Grid>
					</VForm>
				</Paper>
			</Box>
		</Modal>
	);
};
